import React, { useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { Alert, Button, ButtonSwitch, Col, Row } from "@intech/web-ui";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { LoadingComponent } from "@components";

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
}

interface State {
  PPE: string;
  CorCheckbox: string;
  checked: boolean;
  ContriquiComRisco: boolean;
  condicaoAtivoAssistidoPlanoA: boolean;
}

export const Passo8: React.FC<IProps> = ({
  avancar,
  voltar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);

  const [PPE, setPPE] = useState<string>("");
  // const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>(null);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        const dados = await context.buscarDadosParticipante();
        const dadosOriginais = await context.buscarDadosOriginais();

        setPPE(dados.POLIT_EXP || dadosOriginais.POLIT_EXP || "");
        // setDadosOriginais(dadosOriginais);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);



  async function salvarDados() {
    try {
      const dados = await context.buscarDadosParticipante();
      dados.POLIT_EXP = PPE;
      context.salvarDadosParticipante(dados);
      return true;
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }


  async function handleVoltar() {
    try {
      if (await salvarDados()) {
        voltar();
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }

  async function handleAvancar() {
    try {
      if (await salvarDados()) {
        avancar();
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <Alert type={"info"}>{"Declaro para fins do atendimento às exigências da Instrução PREVIC nº 18/2014 e nº 34/2020 que:"}</Alert>

          <div className={"alert alert-info"}>
            {"Caso precise, clique abaixo para realizar o download do PDF das Instruções PREVIC:"}
            <br />
            <a className={"btn btn-link"} href={"https://www.gov.br/economia/pt-br/orgaos/entidades-vinculadas/autarquias/previc/regulacao/normas/instrucoes/instrucoes-previc/2014/instrucao-previc-no-18-de-26-de-dezembro-de-2014.pdf/view"} target={"_blank"}>{"Instrução Previc nº 18, de 26 de dezembro de 2014.pdf"}</a>
            <br />
            <a className={"btn btn-link"} href={"https://www.gov.br/previc/pt-br/normas/instrucao/instrucoes-previc/2020/instrucao-previc-no-34-de-28-de-outubro-de-2020.pdf/view"} target={"_blank"}>{"Instrução Previc nº 34, de 28 de outubro de 2020.pdf"}</a>
          </div>
          {/* 
          <Row>
            <Col>
              <Row>
                <Col className={"col-lg-1"}>
                  <ButtonSwitch
                    activeType={"success"}
                    inactiveType={"light"}
                    inactiveIcon={" "}
                    checked={PPE === "S"}
                    onChange={() => setPPE("S")}
                  />
                </Col>
                <Col>
                  {"ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                </Col>
              </Row>
            </Col>

            <Col>
              <Row>
                <Col className={"col-lg-1"}>
                  <ButtonSwitch
                    activeType={"success"}
                    inactiveType={"light"}
                    inactiveIcon={" "}
                    checked={PPE !== "S"}
                    onChange={() => setPPE("N")}
                  />
                </Col>
                <Col>
                  {"NÃO ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                </Col>
              </Row>
            </Col>
          </Row> */}

          <Row className={"mb-2"}>
            <Col className={"d-flex justify-content-end"}>
              <ButtonSwitch
                activeType={"success"}
                inactiveType={"light"}
                inactiveIcon={" "}
                activeTitle={"ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                inactiveTitle={"ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                checked={PPE === "S"}
                onChange={() => setPPE("S")}
              />
            </Col>

            <Col>
              <ButtonSwitch
                activeType={"success"}
                inactiveType={"light"}
                inactiveIcon={" "}
                activeTitle={"NÃO ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                inactiveTitle={"NÃO ESTOU enquadrado(a) como \"Pessoa Exposta Politicamente\""}
                checked={PPE === "N"}
                onChange={() => setPPE("N")}
              />
            </Col>
          </Row>


          <Alert type={"info"}>
            {"Sendo \"pessoa exposta politicamente\" pessoa natural que desempenha ou tenha desempenhado, nos cinco anos anteriores, cargo, emprego ou função pública relevantes, assim como funções relevantes em organizações internacionais."}
          </Alert>

          <Row>
            <Col>
              <Button
                type={"secondary"}
                title={"Voltar"}
                icon={<FaAngleDoubleLeft />}
                onClick={handleVoltar}
                loadingText={"Voltando..."}
                usesLoading
                block
                iconRight
              />
            </Col>

            <Col>
              <Button
                type={"primary"}
                title={"Continuar"}
                icon={<FaAngleDoubleRight />}
                onClick={handleAvancar}
                loadingText={"Continuando..."}
                usesLoading
                block
              />
            </Col>
          </Row>
        </>)}
    </>
  );
}
